/**
 * Created by vblanco on 27/04/2017.
 */
(function (angular) {
    'use strict';

    angular
        .module('app')
        .controller('EjemplarUsuarioAdminController', EjemplarUsuarioAdminController);

    /* @ngInject */
    function EjemplarUsuarioAdminController($stateParams, Ejemplar, NG_TABLE_DEFAULT_PARAMS, NgTableParams, NgTableHelper) {

        var vm = this;

        vm.item = Ejemplar;
        vm.function = "findEjemplaresByCreador";
        vm.creador = $stateParams.creadorLogin;

        vm.pagina = $stateParams.page ? $stateParams.page : 1;
        vm.elementosPorPagina = NG_TABLE_DEFAULT_PARAMS.size;
        vm.filter = {
            login: $stateParams.creadorLogin,
            key: undefined,
            id: $stateParams.edicionId,
            revisado: undefined,
            publicado: undefined
        };
        vm.tableParams = new NgTableParams({
            count: vm.elementosPorPagina,
            page: vm.pagina,
            filter: vm.filter,
            sorting: {'edicion.ultimaModificacion': 'desc'}
        }, NgTableHelper.settings(vm));

        vm.secondsToDate = function (seconds) {

            var date = new Date(seconds * 1000);

            return fixDate(date.getDate(), 2) + "-" + fixDate(date.getMonth() + 1, 2) + "-" + fixDate(date.getFullYear(), 4)
            + " " + fixDate(date.getHours(), 2) + ":" + fixDate(date.getMinutes(), 2) + ":" + fixDate(date.getSeconds(), 2);

        };

        function fixDate (number, expectedLength) {

            var result = new String(number);
            while (result.length < expectedLength) result = "0" + result;

            return result;

        }

    }

})(angular);
